export const caseStudies = [
  {
    id: 1,
    title: "Retail Management System",
    description:
      "Complete POS and inventory solution for multi-location retail chain",
    features: [
      "Real-time inventory tracking across 15 locations",
      "Integrated payment processing and reporting",
    ],
    image: "/api/placeholder/400/300",
    category: "Retail",
  },
  {
    id: 2,
    title: "Secure Services Portal",
    description: "Secure online services portal with document management",
    features: [
      "Role-based access control and audit trails",
      "Automated workflow for document processing",
    ],
    image: "/api/placeholder/400/300",
    category: "Operations",
  },
  {
    id: 3,
    title: "Educational Platform",
    description: "Student management system with analytics dashboard",
    features: [
      "Comprehensive student tracking and reporting",
      "Parent portal with real-time updates",
    ],
    image: "/api/placeholder/400/300",
    category: "Education",
  },
];
